/** Technical maximum of WebFS concurrent connections through web socket allowed by browsers */
export const MAX_CONCURRENT_CHUNKS = 6;
